import script from "./AIAssistantSummary.vue?vue&type=script&setup=true&lang=ts"
export * from "./AIAssistantSummary.vue?vue&type=script&setup=true&lang=ts"

import "./AIAssistantSummary.vue?vue&type=style&index=0&id=6d4fcf89&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d4fcf89"]])

export default __exports__